import axios from '../request/http';


const task = {
    // 任务信息列表
    taskInfoList(params) {
        return axios.get("/admin/tasks/list", {params});
    },
    // 禁用启动
    taskInfoStatus(params) {
        return axios.get("/admin/tasks/editStatus", {params});
    },
    // 新增
    taskInfo(data) {
        return axios.post("/admin/tasks/addOrEdit", data)
    },
    // 审核信息列表
    examineInfo(params) {
        return axios.get("/admin/tasks/userNote/auditlist", {params});
    },
    // 审核状态
    examineStatus(params) {
        return axios.get("/admin/tasks/userNote/audit", {params});
    },
}

export default task;


// WEBPACK FOOTER //
// ./src/api/task.js